import { applyMiddleware, createStore } from "redux";
import productQtyCheck from "./middlewares/productQtyCheck";
import rootReducer from "./rootReducer";

const store = createStore(rootReducer, applyMiddleware(productQtyCheck));
export default store;
